import { Widget } from "@/lib/api";

export enum Converters {
  HTML2HTML = "html2html",
  RAW = "raw",
  PGM2HTML = "pgm2html",
  JS2JSON = "js2json",
  REPORT = "report",
}

export enum Players {
  NONE = "none",
  SIMPLE = "simple",
  SIMPLE_SELECTOR = "simple+selector",
}

export enum LegacyProducts {
  GENERIC = "generic",
  STATIC_FILE = "static",
  FILE = "file",
  FILES = "file_list",
  OPMET = "opmet_form",
}

export enum OpmetForms {
  REGION = "region",
  AIRPORT = "airport",
  FLIGHT_TABLE = "flight-table",
  FLIGHT_CALCULATE_VFR = "flight-calculate-vfr",
  FLIGHT_CALCULATE_IFR = "flight-calculate-ifr",
}

export enum WidgetTypes {
  LEGACY = "legacy",
  MAP = "map",
  RICH_TEXT = "rich_text",
  LINE_GRAPH = "line_graph",
  OPMET_REPORT = "opmet_report",
  EARLY_WARNING_TABLE = "early_warning_table",
  OBSERVATIONS_MAP = "observations_map",
  MODEL_MAP = "model_map",
  MARITIME_BROADCAST = "maritime_broadcast",
  MARITIME_FORECAST = "maritime_forecast",
  MARITIME_SEICHES = "maritime_seiches",
  TIME_SERIES = "time_series",
}

export type Renderer =
  | "highcharts"
  | "html"
  | "iframe"
  | "image"
  | "images"
  | "link"
  | "probabilities"
  | "radar"
  | "report"
  | "seiches"
  | "sight"
  | "text"
  | "textcode"
  | "timeseries"
  | "wind"
  | "links";

export type FormValues = Widget;
